import { Injectable, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { map, switchMap, filter, catchError, withLatestFrom } from 'rxjs/operators';
import * as actions from '../actions';
import {DevicesService} from '../../services/devices.service';
import {User} from '../../models/user';
import * as fromStore from '../../store';
import { Store, select } from '@ngrx/store';
import {UsersState} from '../reducers/user.reducers';
import { DevicesStatusPack } from '../../models/devices';

@Injectable()
export class DevicesStatusEffects {
  private actions$ = inject(Actions);
  private deveicesService = inject(DevicesService);
  private store$ = inject(Store<fromStore.State>);

  constructor() {}

  getDevicesStatusEffect$ = createEffect(() => this.actions$.pipe(
    ofType(actions.DevicesStatusTypes.GET_DEVICES_STATUS),
    map((action: actions.GetDevicesStatusAction) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, currentUser]) => {
      const param = (payload !== null && payload.regionIds !== null && payload.regionIds !== undefined) ?
                    {account: currentUser.currentUser, otp: currentUser.otp, RegionIds: payload.regionIds} :
                    {account: currentUser.currentUser, otp: currentUser.otp};
      return this.deveicesService.getDevicesStatus(param).pipe(
        map((res: any) => {
          const msg = res?.msg || {};
          if (res?.result) {
            // null-safe：避免 Object.keys(null) 丟錯走 Fail，把既有 Device 清單清掉
            const result: DevicesStatusPack = {
              DeviceList: msg.device_status ?? [],
              ShareDeviceList: msg.shared_devices ?? [],
              ShareGroupDeviceList: msg.shared_group_devices ?? []
            };
            return new actions.GetDevicesStatusSuccessAction(result);
          }
          return new actions.GetDevicesStatusFailAction(res);
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => of(new actions.GetDevicesStatusFailAction(error)))
      );
    })
  ));
  getDeviceDetailsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(actions.DeviceDetailsType.GET_DEVICE_DETAILS),
    map((action: actions.GetDevicesDetails) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([actionSN, currentUser]) => {
      const params = {otp: currentUser.otp, sn: actionSN};
      return this.deveicesService.getDeviceDetails(params).pipe(
        map((res: any) => {
          if (res.result) {
            const deviceStatus = {
              ...res.msg.device_status,
              dcode: res.msg.dcode,
            };
            return new actions.GetDevicesDetailsSuccess(deviceStatus);
          } else {
            return new actions.GetDeviceDetailsFail(res);
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => of(new actions.GetDeviceDetailsFail(error)))
      );
    })
  ));
}
